import { render } from "./SkeletonReports.vue?vue&type=template&id=cbaad848"
import script from "./SkeletonReports.vue?vue&type=script&lang=js"
export * from "./SkeletonReports.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__